import React, { useState } from 'react';

import IconButton from '~/components/core/Atomic/Buttons/IconButton';
import InputAdornment from '~/components/core/Atomic/InputAdornment';
import { EyeIcon, EyeSlashIcon } from '~/components/icons';
import TextFieldFormik from '~/components/TextFieldFormik';

interface SecretTextFieldFormikProps {
  id: string;
  label: string;
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  showLabel: string;
  hideLabel: string;
}

// A write-only secret: the server never sends the stored value back, so the eye can only ever
// reveal what was typed into this field.
const SecretTextFieldFormik: React.FC<SecretTextFieldFormikProps> = ({
  id,
  label,
  className,
  fullWidth,
  disabled,
  showLabel,
  hideLabel,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  return (
    <TextFieldFormik
      id={id}
      label={label}
      className={className}
      fullWidth={fullWidth}
      disabled={disabled}
      InputProps={{
        type: isVisible ? 'text' : 'password',
        endAdornment: (
          <InputAdornment position="end">
            <IconButton aria-label={isVisible ? hideLabel : showLabel} onClick={() => setIsVisible(!isVisible)}>
              {isVisible ? <EyeIcon iconColor="currentColor" /> : <EyeSlashIcon iconColor="currentColor" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SecretTextFieldFormik;
